import { notification } from 'ant-design-vue'
import store from '../store/index'
import router from '../router/index'
let socketTask
let timer = null
export const connect = id => {
  socketTask = new WebSocket(
    location.href.includes('121.41.10.247')
      ? `ws://121.41.10.247:8081/stuff/webSocket/info/${id}`
      : location.href.includes('lockan.maitewang.com')
        ? `wss://lockan.maitewang.com/stuff/webSocket/info/${id}`
        : `ws://121.41.10.247:8081/stuff/webSocket/info/${id}`
  )
  socketTask.onopen = function () {
    console.log('websocket已连接成功')

    socketTask.send('ping')
    timer = setInterval(() => {
      socketTask.send('ping')
    }, 30000)
    socketTask.onmessage = res => {
      const data = JSON.parse(res.data)

      console.log(data)
      // type == 1  企业下单自动分单：每次有新的订单过来就清除上一次的弹窗，手动关闭弹窗
      if (data.type == 1) {
        notification.destroy()
        notification.info({
          message: data.title,
          description: data.text,
          duration: null,
          onClick () {
            router.push({
              name: 'orderList',
              params: {
                jumpList: { orderStatus: 'customerServiceApply', isMyOrder: 1 }
              }
            })
          }
        })
        // 自动派单语音提醒
        var Music = new Audio('http://tts.youdao.com/fanyivoice?word=您有新的订单需要处理&le=zh&keyfrom=speaker-target')
        Music.play()
      } else if (data.type == 2) {
        // type == 2 客户下单：例如电信下单
        notification.destroy()
        notification.info({
          message: data.title,
          description: data.text,
          duration: null
        })
        // 客户下单数量
        if (data.count) {
          store.commit('getXiadanCount', data.count)
        }
        // 自动派单语音提醒
        var Music1 = new Audio(
          'http://tts.youdao.com/fanyivoice?word=您有新的订单需要处理&le=zh&keyfrom=speaker-target'
        )
        Music1.play()
      } else if (data.type == 3) {
        const key = `open${Date.now()}`
        notification.info({
          message: data.title,
          description: data.text + ',' + '提醒事项:' + data.remark,
          duration: 10,
          btn: h =>
            h('div', [
              h(
                'a-button',
                {
                  props: {
                    size: 'small'
                  },
                  attrs: {
                    style: 'margin-right:40px'
                  },
                  on: {
                    click: () => notification.close(key)
                  }
                },
                '稍后处理'
              ),
              h(
                'a-button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },

                  on: {
                    click: () => {
                      router.push('/order/orderList?orderId=' + data.orderId + '&time=' + key)
                      notification.close(key)
                    }
                  }
                },
                '立即处理'
              )
            ]),
          key
        })
      } else if (data.type == 4) { // 乐橙凭证过期
        store.commit('setLcStatus', 0)
      } else {
        // 催单和问题反馈提醒
        notification.info({
          message: data.title,
          description: data.text,
          duration: 5
        })
        // 催单数量
        if (data.count) {
          store.commit('getCuidanCount', data.count)
        }
      }
    }
  }

  socketTask.onclose = function () {
    console.log('连接已关闭...')
    clearInterval(timer)
    timer = null
    setTimeout(() => {
      connect()
    }, 500)
  }
}
export const close = () => {
  socketTask.close()
  clearInterval(timer)
  timer = null
}
